
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.985.087C7.465.087.565 7.002.565 15.522s6.9 15.434 15.42 15.434c8.535 0 15.45-6.914 15.45-15.434S24.52.087 15.985.087zM8.283 11.663a2.315 2.315 0 114.63 0 2.315 2.315 0 01-4.63 0zm13.12-2.315a2.315 2.315 0 100 4.63 2.315 2.315 0 000-4.63zM11.37 20.924v-2.315h9.26v2.315h-9.26zm-7.718-5.402C3.652 22.344 9.178 27.87 16 27.87c6.822 0 12.348-5.526 12.348-12.348C28.348 8.7 22.822 3.174 16 3.174 9.178 3.174 3.652 8.7 3.652 15.522z","fill":"#ABABAB"}})])
          )
        }
      }
    